
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export const FIREBASE_VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;